import { useState } from "react";
import Button from "~/components/lib/Button";
import Heading from "~/components/lib/Heading";
import Input from "~/components/lib/Input";
import InputForm from "~/components/lib/InputForm";
import Link from "~/components/lib/Link";
import Text from "~/components/lib/Text";
import { useNewsletterSignup } from "~/hooks/useNewsletterSignup";

const NewsletterSignup: React.FC = () => {
  const [email, setEmail] = useState("");
  const { error, clearError, isSubmitting, isSuccess, subscribe } =
    useNewsletterSignup();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    subscribe(email);
  };

  if (isSuccess) {
    return (
      <div className="blog-sidebar__newsletter">
        <Text
          element="p"
          className="blog-sidebar__newsletter-success"
        >
          You&apos;re signed up!
        </Text>
      </div>
    );
  }

  return (
    <div className="blog-sidebar__newsletter">
      <Heading
        element="h2"
        size="base"
        className="blog-sidebar__newsletter-title"
      >
        Get more articles
      </Heading>
      <Text
        element="div"
        className="blog-sidebar__newsletter-subtitle"
      >
        in your inbox
      </Text>
      <Text
        element="p"
        className="blog-sidebar__newsletter-text"
      >
        Subscribe to our mailing list and get interesting articles and updates
        to your email inbox.
      </Text>
      <InputForm
        className="blog-sidebar__newsletter-form"
        onSubmit={handleSubmit}
        Input={
          <Input
            name="email"
            placeholder="Enter your email here"
            value={email}
            error={error ?? undefined}
            onChange={(event) => {
              setEmail(event.target.value);
              clearError();
            }}
          />
        }
        Button={<Button disabled={isSubmitting}>Sign Up Now</Button>}
      />
      <Text
        element="p"
        className="blog-sidebar__newsletter-text"
      >
        We respect your privacy and take protecting it seriously. Our{" "}
        <Link to="/privacy-policy">Privacy Policy</Link>.
      </Text>
    </div>
  );
};

export default NewsletterSignup;
